import { DownloadOutlined } from '@ant-design/icons';
import { Spin, Table } from 'antd';
import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { t_billing_process } from 'types';

type Props = {
  dataSource: t_billing_process[];
  exportBill: any;
};

const TableListBill: FC<Props> = ({ dataSource, exportBill }) => {
  const [loadingIndex, setLoadingIndex] = useState<number | undefined>(undefined);

  const history = useHistory();
  const columns: any = [
    {
      title: '取引先番号',
      dataIndex: 'facility_code',
      key: 'facility_code',
      width: '25%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '請求月',
      dataIndex: 'invoice_month',
      key: 'invoice_month',
      width: '25%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月度` : ''}</div>,
        };
      },
    },
    {
      title: '医療機関名',
      dataIndex: 'lookup_items',
      key: 'facility_name',
      width: '37%',
      align: 'center',
      render(text: any) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text.facility_id.facility_name}</div>,
        };
      },
    },
    {
      title: '',
      dataIndex: 'i_id',
      key: 'i_id',
      width: '13%',
      align: 'center',
      render(text: string, row: t_billing_process, index: number) {
        return {
          props: {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#A956EA',
              color: 'white',
              cursor: 'pointer',
            },
            className: 'standardFont',
            onClick: async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              event.stopPropagation();
              if (loadingIndex === undefined) {
                setLoadingIndex(index);
                try {
                  await exportBill({
                    i_id: text,
                    facility_name: row.lookup_items.facility_id.facility_name ?? '',
                    invoice_month: row.invoice_month ?? '',
                    facility_id: row.lookup_items.facility_id.i_id ?? '',
                    invoice_id: row.invoice_id ?? '',
                    facility_code: row.lookup_items.facility_id.facility_code ?? '',
                  });
                } finally {
                  setLoadingIndex(undefined);
                }
              }
            },
          },
          children:
            loadingIndex === index ? (
              <Spin size="default" />
            ) : (
              <>
                請求書出力
                <DownloadOutlined style={{ marginLeft: '4px' }} />
              </>
            ),
        };
      },
    },
  ];

  return (
    <div>
      <Table
        onRow={(record) => {
          return {
            onClick: () => {
              loadingIndex === undefined && history.push('/billings/detail', { bill: record });
            },
          };
        }}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </div>
  );
};

export default TableListBill;
